import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './layout/AppShell';
import { AuthGuard } from './auth/AuthGuard';
import { Dashboard } from './pages/Dashboard';
import { EnviosList } from './pages/Envios/EnviosList';
import { EnvioForm } from './pages/Envios/EnvioForm';
import { EnvioDetail } from './pages/Envios/EnvioDetail';
import { DeCAList } from './pages/DeCA/DeCAList';
import { DeCADetail } from './pages/DeCA/DeCADetail';
import { DeCAWizardRoute } from './pages/DeCA/DeCAWizard';
import { VehiculosList } from './pages/Vehiculos/VehiculosList';
import { ConductoresList } from './pages/Conductores/ConductoresList';
import { CargadoresList } from './pages/Cargadores/CargadoresList';
import { TransportistasList } from './pages/Transportistas/TransportistasList';
import { OrigenesDestinosList } from './pages/OrigenesDestinos/OrigenesDestinosList';
import { UsuariosList } from './pages/Usuarios/UsuariosList';
import { Informes } from './pages/Informes/Informes';
import { Configuracion } from './pages/Configuracion/Configuracion';
import { Auditoria } from './pages/Auditoria/Auditoria';
import { Login } from './pages/Login';
import Signup from './pages/Signup';
import { VerificarEmail } from './pages/VerificarEmail';
import { VerificaTuEmail } from './pages/VerificaTuEmail';
import { ForgotPassword } from './pages/ForgotPassword';
import OnboardingEmpresa from './pages/OnboardingEmpresa';
import { ResetPassword } from './pages/ResetPassword';

export default function App() {
  return (
    <Routes>
      {/* Rutas publicas */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      {/* Sprint 5.1: verificacion de email (link clickeado desde el correo) */}
      <Route path="/verificar-email" element={<VerificarEmail />} />
      {/* Pantalla post-signup: "revisa tu email" + reenviar */}
      <Route path="/verifica-tu-email" element={<VerificaTuEmail />} />
      {/* Sprint 5.2: recuperacion de password */}
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Rutas protegidas: sesiones locales (signup/login email+password)
          o MSAL (Entra ID / mock dev). AuthGuard acepta ambas. */}
      <Route
        element={
          <AuthGuard>
            <AppShell />
          </AuthGuard>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/envios" element={<EnviosList />} />
        <Route path="/envios/nuevo" element={<EnvioForm />} />
        <Route path="/envios/:id" element={<EnvioDetail />} />
        <Route path="/envios/:id/editar" element={<EnvioForm />} />
        <Route path="/deca" element={<DeCAList />} />
        <Route path="/deca/nuevo" element={<DeCAWizardRoute />} />
        <Route path="/deca/:id/editar" element={<DeCAWizardRoute />} />
        <Route path="/deca/:id" element={<DeCADetail />} />
        <Route path="/vehiculos" element={<VehiculosList />} />
        <Route path="/conductores" element={<ConductoresList />} />
        <Route path="/cargadores" element={<CargadoresList />} />
        <Route path="/transportistas" element={<TransportistasList />} />
        <Route path="/origenes-destinos" element={<OrigenesDestinosList />} />
        <Route path="/usuarios" element={<UsuariosList />} />
        <Route path="/informes" element={<Informes />} />
        <Route path="/configuracion" element={<Configuracion />} />
        <Route path="/auditoria" element={<Auditoria />} />
      </Route>

      {/* Ruta protegida SIN AppShell: el wizard post-login para dar de
          alta la primera empresa. Pantalla limpia, como Signup. */}
      <Route
        element={
          <AuthGuard>
            <OnboardingEmpresa />
          </AuthGuard>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
